import { type PointerEvent } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { IconAdvanced } from '@/components/icons/IconAdvanced'
import { useHeaderButtons } from '@/components/providers/HeaderButtonsProvider'
import { useToggleFiltersPanel } from '@/hooks/useToggleFiltersPanel'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import styles from './HeaderButtonFilters.module.scss'

export const HeaderButtonFilters = () => {
  const { filtersCount, isActive } = useHeaderButtons()
  const dispatch = useReduxDispatch()
  const filtersStatus = useReduxSelector((s) => s.view.filtersStatus)
  const mobileStatus = useReduxSelector((s) => s.view.mobileStatus)
  const isOpenMobile = mobileStatus === 'filters'
  const toggleFiltersPanel = useToggleFiltersPanel()

  const onPointerEnter = (e: PointerEvent<HTMLButtonElement>) => {
    if (e.pointerType === 'mouse') dispatch(viewActions.hoverFilters())
  }

  return (
    <div
      className={cn(styles.container, {
        filtersStatus,
        isActive,
        isOpenMobile,
        styles,
      })}
      {...getClickawayIgnoreProps(['collapse-expanded'])}
    >
      <ButtonRoot
        aria-label='Expand'
        className={styles.button}
        onClick={toggleFiltersPanel}
        onPointerEnter={onPointerEnter}
      >
        <IconAdvanced.Root count={filtersCount} variant='filters' />
      </ButtonRoot>
    </div>
  )
}
